__turbopack_context__.v({
  "button": "VariantSelector-module__XRfF2a__button",
  "buttonGroup": "VariantSelector-module__XRfF2a__buttonGroup",
  "buttonSelected": "VariantSelector-module__XRfF2a__buttonSelected",
  "container": "VariantSelector-module__XRfF2a__container",
  "controls": "VariantSelector-module__XRfF2a__controls",
  "hint": "VariantSelector-module__XRfF2a__hint",
  "label": "VariantSelector-module__XRfF2a__label",
  "preview": "VariantSelector-module__XRfF2a__preview",
  "previewText": "VariantSelector-module__XRfF2a__previewText",
});
